/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const TOTAL_PROVENANCE = [
    {
        name: "2008 WR Photo Finish",
        subtitle: "Track and Field",
        assetId: "17",
        timeLine: [
            {
                id: 1,
                key: "startingBlock",
                label: "Starting Block",
            },
            {
                id: 2,
                key: "gunShot",
                label: "Gun Shot",
            },
            {
                id: 3,
                key: "50mtr-into-race",
                label: "50mtr into Race",
            },
            {
                id: 4,
                key: "worldrecordset",
                label: "World record set",
            },
        ],
    },
];

export const PROVENANCE_DETAIL = [
    {
        assetId: "17",
        provenance: [
            {
                idx: 1,
                title: "Starting Block",
                subtitle: [
                    "These sturdy starting blocks, made of aluminium and stainless steel, feature an extra largewnon-slip adjustable footrest for optimal stability, fully assisting the athlete’s performance. The loudspeaker transmits the starter’s instructions, the gunshot, and the possible false start signal. The distance between the feet, as well as the foot’s starting angle can be freely adjusted.",
                    "Footrest angle can be adjusted by 4 positions between 55° and 73°. Footrest can be moved horizontally within 16 positions spaced of 35.5 mm giving a maximum distance of 502.5 mm between front and back feet.",
                    "Top Features:",
                    "Suitable for all competitions level",
                    "Monitor up to 10 lanes simultaneous",
                    "Acoustic signal in case of false start",
                    "Force curve display for each lane",
                ],
                // serialNo: 'Rare #/1',
                img: "https://dev-dc.vlinder.io/imgsrv/ipfs/QmTJFM4QPeN5aYc7uDZrHNdsA8oXQrn58fspRNNV3PmSYp",
                // tag: 'DIAMOND',
                // productCategory: 'collectibles',
                // category: 'diamond',
                price: [
                    {
                        type: "fiat",
                        currency: "USD",
                        locale: "en-US",
                        amount: 1500.0,
                    },
                    {
                        type: "crypto",
                        currency: "ETH",
                        amount: 0.5,
                    },
                ],
                createdBy: {
                    userName: "SWISS TIMING",
                    userId: "swiss-timing",
                    link: "/swiss-timing",
                    authProofUrl:
                        "https://gateway.pinata.cloud/ipfs/QmTJFM4QPeN5aYc7uDZrHNdsA8oXQrn58fspRNNV3PmSYp",
                },
                meta: [
                    {
                        key: "Item",
                        value: "Track & field starting block with loudspeaker",
                    },
                    {
                        key: "Dimensions (LxWxH) ",
                        value: "990 x 410 x 220 to 260 mm (depend to the position of the footrest)",
                    },
                    {
                        key: "Weight",
                        value: "13 KG",
                    },
                    {
                        key: "Acoustic signals",
                        value: "False start: 104 dB @ 1m, Gun shot: 114 dB @ 1m, 1x Tuchel 7pMT (for thrust sensors and loudspeaker)",
                    },
                    {
                        key: "Operating temperature ",
                        value: "0 to +50°C ",
                    },
                    {
                        key: "Storage temperature  ",
                        value: "-10°C to +60°C  ",
                    },
                    {
                        key: "Protection",
                        value: "IP44",
                    },
                    {
                        key: "Certifications",
                        value: "CE and RoHS compliant IAAF Certified Product",
                    },
                ],
                // actions: [
                //     {
                //         key: "buyNowFiat",
                //         title: "Buy in USD"
                //     },
                //     {
                //         key: "buyNowCrypto",
                //         title: " Buy in ETH"
                //     }
                // ],
                images: [
                    {
                        original:
                            "https://dev-dc.vlinder.io/imgsrv/ipfs/QmTJFM4QPeN5aYc7uDZrHNdsA8oXQrn58fspRNNV3PmSYp",
                        thumbnail:
                            "https://dev-dc.vlinder.io/imgsrv/ipfs/QmTJFM4QPeN5aYc7uDZrHNdsA8oXQrn58fspRNNV3PmSYp/:/rs=h:70",
                        thumbnailHeight: "70",
                        thumbnailClass: "image-thumb",
                    },
                ],
            },
            {
                idx: 2,
                title: "E Gun",
                subtitle: [
                    "The new generation flash gun replaces powder gun and transducer to signal the start to the athletes and trig the timing devices. When the starter active the gun trigger, simultaneously, a sound is played, a flash is emitted and a start pulse is given to the timing device.",
                    "This new starting device was used for the first time at the Vancouver Winter Olympic Games, it combines the latest Swiss Timing technologies, a brand new futuristic design and fits the latest security and safety standards",
                    "Top Features",
                    "Futuristic and lightweight design",
                    "Integrated visual flash",
                    "Simultaneous visual and acoustic signal",
                    "Gun status LEDs indicators",
                    "Supplied with ready-to-use software",
                    "Customizable sounds",
                    "High security level",
                    "Easy to use",
                ],
                // serialNo: 'Rare #/2',
                img: "https://dev-dc.vlinder.io/imgsrv/ipfs/QmaTQzCGHAuX4kdwpFH1upckpL5sYTfdTmdv29XMuZ9WfP/:/rs=w:500",
                // tag: 'DIAMOND',
                // category: 'diamond',
                price: [
                    {
                        type: "fiat",
                        currency: "USD",
                        locale: "en-US",
                        amount: 2000.0,
                    },
                    {
                        type: "crypto",
                        currency: "ETH",
                        amount: 0.55,
                    },
                ],
                createdBy: {
                    userName: "SWISS TIMING",
                    userId: "swiss-timing",
                    link: "/swiss-timing",
                    authProofUrl:
                        "https://gateway.pinata.cloud/ipfs/QmaTQzCGHAuX4kdwpFH1upckpL5sYTfdTmdv29XMuZ9WfP",
                },
                meta: [
                    {
                        key: "Weight",
                        value: "1 Kg (with cable, 350 gr without cable) ",
                    },
                    {
                        key: "Cable length",
                        value: "7m",
                    },
                    {
                        key: "Power supply",
                        value: "DC input, 7-18V DC ",
                    },
                    {
                        key: "Power consumption",
                        value: "max. 1.6 A @ 12 VDC ",
                    },
                    {
                        key: "Standby",
                        value: "10mA @ 12VDC (when flash loaded) ",
                    },
                    {
                        key: "Flash duration",
                        value: "0.1s F",
                    },
                    {
                        key: "Lash visibility",
                        value: "Sun visible >200m ",
                    },
                    {
                        key: "Flash viewing angle",
                        value: "DC input, 7-18V DC ",
                    },
                    {
                        key: "Operating temperature",
                        value: "0 to +50 °C",
                    },
                    {
                        key: "Storage temperature",
                        value: "20 to +70 °C Protection: IP65 Certifications: and RoHS compliant",
                    },
                    {
                        key: "Dimensions",
                        value: "118 x 25 x 80 mm",
                    },
                ],
                // actions: [
                //     {
                //         key: "buyNowFiat",
                //         title: "Buy in USD"
                //     },
                //     {
                //         key: "buyNowCrypto",
                //         title: " Buy in ETH"
                //     }
                // ],
                images: [
                    {
                        original:
                            "https://dev-dc.vlinder.io/imgsrv/ipfs/QmaTQzCGHAuX4kdwpFH1upckpL5sYTfdTmdv29XMuZ9WfP",
                        thumbnail:
                            "https://dev-dc.vlinder.io/imgsrv/ipfs/QmaTQzCGHAuX4kdwpFH1upckpL5sYTfdTmdv29XMuZ9WfP/:/rs=h:70",
                        thumbnailHeight: "70",
                        thumbnailClass: "image-thumb",
                    },
                ],
            },
            {
                idx: 3,
                title: "50mtr into Race , Bolt becoming leader",
                subtitle: [
                    "Bolt overtook all the opponent sprinters midway through the run & maintained his lead throughout to create a World Record. Bolt started celebrating soon after gaining the lead.",
                    "Bolt later explained 'As soon as I saw I had covered the field and I knew I would win, I was very happy and I started to celebrate.'",
                ],
                img: "https://i.ibb.co/9THBcbT/1.jpg",
                createdBy: {
                    userName: "SWISS TIMING",
                    userId: "swiss-timing",
                    link: "/swiss-timing",
                    authProofUrl:
                        "https://gateway.pinata.cloud/ipfs/QmUTLT2mjsHa8ybEYYV8YU1Qfo8jXetuJxeq6WV4eQjosM",
                },
                // meta: [
                //     {
                //         key: "Year",
                //         value: "1974"
                //     },
                //     {
                //         key: "Denomination",
                //         value: "$50"
                //     },
                //     {
                //         key: "Catalog",
                //         value: "J00295254"
                //     },
                //     {
                //         key: "Plate Position",
                //         value: "D"
                //     },
                //     {
                //         key: "Grade",
                //         value: "35"
                //     }
                // ],
                buttons: [
                    {
                        key: "buyNowFiat",
                        title: "Buy in USD",
                    },
                    {
                        key: "buyNowCrypto",
                        title: " Buy in ETH",
                    },
                ],
                images: [
                    {
                        original:
                            "https://dev-dc.vlinder.io/imgsrv/ipfs/QmUTLT2mjsHa8ybEYYV8YU1Qfo8jXetuJxeq6WV4eQjosM",
                        thumbnail:
                            "https://dev-dc.vlinder.io/imgsrv/ipfs/QmUTLT2mjsHa8ybEYYV8YU1Qfo8jXetuJxeq6WV4eQjosM/:/rs=h:70",
                        thumbnailHeight: "70",
                        thumbnailClass: "image-thumb",
                    },
                ],
            },
            {
                idx: 4,
                title: "World Record set",
                subtitle: [
                    "The men's 100 metres sprint event at the 2008 Olympic Games took place on 15 and 16 August at the Beijing National Stadium. Eighty athletes from 64 nations competed. Each nation was limited to 3 athletes per rules in force since the 1930 Olympic Congress. The final was won by Jamaican Usain Bolt in a world record time of 9.69 seconds. It was Jamaica's first title in the event, and first medal in the event since 1976. Jamaica became the first country to join the men's 100 metre winners since Trinidad and Tobago, also in 1976; Richard Thompson won that country's fourth overall medal in the event with his silver.",
                    "Holding a considerable lead 70 metres into the race, Bolt opened his arms in celebration before slapping his chest. British athlete and television presenter Kriss Akabusi criticized this gesture as showboating, noting that it cost Bolt an even faster record time. IOC president Jacques Rogge also criticized Bolt's actions as disrespectful. Bolt denied that this was the purpose of his mid-race celebration by saying 'I wasn't bragging. When I saw I wasn't covered, I was just happy.'",
                ],
                // serialNo: 'Rare #/16',
                img: "https://dev-dc.vlinder.io/imgsrv/ipfs/QmQGyBhc3Zue33TMKfzN9Hhs28g9fKMjcJ2wduZUpUBDHE/:/rs=w:500",
                // tag: 'PLATINUM',
                // category: 'platinum',
                price: [
                    {
                        type: "fiat",
                        currency: "USD",
                        locale: "en-US",
                        amount: 1500.0,
                    },
                    {
                        type: "crypto",
                        currency: "ETH",
                        amount: 0.5123,
                    },
                ],
                createdBy: {
                    userName: "SWISS TIMING",
                    userId: "swiss-timing",
                    link: "/swiss-timing",
                    authProofUrl:
                        "https://gateway.pinata.cloud/ipfs/QmQGyBhc3Zue33TMKfzN9Hhs28g9fKMjcJ2wduZUpUBDHE",
                },
                // meta: [
                //     {
                //         key: "Year",
                //         value: "1974"
                //     },
                //     {
                //         key: "Denomination",
                //         value: "$50"
                //     },
                //     {
                //         key: "Catalog",
                //         value: "J00295254"
                //     },
                //     {
                //         key: "Plate Position",
                //         value: "D"
                //     },
                //     {
                //         key: "Grade",
                //         value: "40"
                //     }
                // ],
                // actions: [
                //     {
                //         key: "buyNowFiat",
                //         title: "Buy in USD"
                //     },
                //     {
                //         key: "buyNowCrypto",
                //         title: " Buy in ETH"
                //     }
                // ],
                images: [
                    {
                        original:
                            "https://dev-dc.vlinder.io/imgsrv/ipfs/QmQGyBhc3Zue33TMKfzN9Hhs28g9fKMjcJ2wduZUpUBDHE",
                        thumbnail:
                            "https://dev-dc.vlinder.io/imgsrv/ipfs/QmQGyBhc3Zue33TMKfzN9Hhs28g9fKMjcJ2wduZUpUBDHE/:/rs=h:70",
                        thumbnailHeight: "70",
                        thumbnailClass: "image-thumb",
                    },
                ],
            },
        ],
    },
];
